
/**************************************************************************************************/
/*   File: /src/app/shared/models/territorial.area.regulations.content.ts                         */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Monday April 1st 2019                                                          */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Apr 19 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { LocalDocumentId } from './local.document.id';
/**
 * The territorial area regulations content
 */
export class TerritorialAreaRegulationsContent {
    /**
     * The delta doc id
     */
    deltaDoc: LocalDocumentId;
    /**
     * The dossier id
     */
    dossierId: number;
    /**
     * The final doc id
     */
    finalDoc: LocalDocumentId;
    /**
     * The territorial area code
     */
    territorialAreaCode: string;
    /**
     * The original doc
     */
    originalDoc?: LocalDocumentId;
}